module.exports = __webpack_public_path__ + "img/magafaim_no.a9b0fb26.png";